import { emptyObj } from 'util/objects'

export const selectBase = state => state.ai || emptyObj

export default selectBase
